import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'
import UnavailableItemActions from '../reducers/unavailableItemReducer'

export function* getUnavailableItem({ merchantKey }) {
  const unavailableItemRef = firebase
    .firestore()
    .collection('unavailable_items')
    .where('merchant_id', '==', merchantKey)

  try {
    const querySnapshot = yield call([unavailableItemRef, unavailableItemRef.get])
    const unavailableItems = {}

    querySnapshot.forEach(doc => {
      unavailableItems[doc.id] = { ...doc.data() }
    })

    yield put(UnavailableItemActions.setUnavailableItem(merchantKey, unavailableItems))
  } catch (err) {
    yield put(UnavailableItemActions.setUnavailableItemLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/unavailableItemSaga.js